import React, { useState, useEffect } from "react";
import { Button, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCartPlus,
  faCartShopping,
  faTimes,
  faWarning,
} from "@fortawesome/free-solid-svg-icons";
import Product from "./Product";
import { useLocation } from "react-router-dom";
import { API_BASE_URL } from "../config";
import ModalAddItemToCart from "./ModalAddItemToCart";
import { useInvoiceContext, useControlContext } from "../context";

const EmptyCart = () => {
  return ( 
    <>
      <p className="text-center" style={{ color: "#dc3545" }}>
        <FontAwesomeIcon
            icon={faWarning}
            style={{ color: "#dc3545" }}
            className="me-2"
          />Atenção:<br />
          Nenhum produto no carrinho.
      </p>
    </>

  );
};


const Cart = (props) => {
  const location = useLocation();
  const queryString = new URLSearchParams(location.search);
  const cartquery = queryString.get("cart") || "Q0Y6Qzow";

  const [modalShow, setModalShow] = useState(false);
  const { cart, setInvoiceCart, setInvoiceTotal, removeItemOfCart } = useInvoiceContext();
  const { progressViewerPayment } = useControlContext();

  const removeItem = (index) => {
    removeItemOfCart(index);
  };

  useEffect(() => {
    const fetchCart = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/getcart/${cartquery}`);
        const jsonData = await response.json();

        const status = response.status;

        if (status === 200) {
          const cart = jsonData.products;

          setInvoiceCart(cart);
        }
      } catch (error) {
        console.error(error.message);
      }
    };

    fetchCart();
  }, [cartquery]);

  useEffect(() => {
    if (progressViewerPayment && cart.length === 0 )
      setModalShow(true);
  }, [progressViewerPayment, cart.length]);

  useEffect(() => {
    const total = cart.reduce((total, item) => {
      return total + parseFloat(item.price);
    }, 0);

    setInvoiceTotal(total);
  }, [cart]);

  const showAddItemModal = () => {
    setModalShow(true);
  };

  return (
    <>
      <ModalAddItemToCart show={modalShow} onHide={() => setModalShow(false)} />
      <Card className="mt-3 mb-3">
        <Card.Header>
          <FontAwesomeIcon
            icon={faCartShopping}
            style={{ color: "#333" }}
            className="me-2"
          />
          Produtos no carrinho:
        </Card.Header>
        <Card.Body>
        {cart.length === 0 ? (
          <EmptyCart />
        ) : (
          cart.map((item, index) => {
            const isRenovation = item.id >= 90 || item.id === 4;

            if (isRenovation) {
              return (
                <Product
                  key={index}
                  index={index}
                  name={item.name}
                  desc={item.desc}
                  price={parseFloat(item.price)}
                />
              );
            } else {
              return (
                <Product
                  key={index}
                  index={index}
                  name={item.name}
                  desc={item.desc}
                  price={parseFloat(item.price)}
                  fullPrice={parseFloat(item.full_price)}
                  actionText={isRenovation ? "renovar" : "remover"}
                  actionHoverColor="#dc3545"
                  actionIcon={faTimes}
                  actionOnClick={() => {
                    removeItem(index);
                  }}
                  hasInfo={item.tem_info}
                  info={item.info}
                />
              );
            }
          })
        )}
          
          <div className="d-flex justify-content-center">
            <Button
              className="mt-3 link-success link-underline link-underline-opacity-0"
              onClick={showAddItemModal}
              variant="link"
            >
              <FontAwesomeIcon icon={faCartPlus} className="me-2" />
              Adicionar Mais Produtos
            </Button>
          </div>
        </Card.Body>
      </Card>
    </>
  );
};

export default Cart;